import { FileDownload } from "@mui/icons-material";
import Button from "e.sic-platform.webclient/src/components/button/Button";
import { useTheme } from "e.sic-platform.webclient/src/services/theme-service/ThemeService";
import { observer } from "mobx-react-lite";

export default observer(function ExportButton({ exportVideoAnalaysis, disabled }: { exportVideoAnalaysis: () => Promise<Blob>, disabled: boolean }) {
    const {themeClass} = useTheme();
    const download = async () => {
        try {
            const blob = await exportVideoAnalaysis();
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'video-analysis.zip';
            a.click();
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error('Download failed:', err);
        }
    };
    return (
        <Button
            id="export"
            onClick={download}
            disabled={disabled}
            icon={{
            svg: FileDownload,
            textKey: "general.export",
            textClass: "actions-header-button-label",
            className: themeClass(["icon-mui"]),
            }}
        />
    );
})